import React from 'react';
import { Link } from 'react-router-dom'
import { AppBar, Typography, Box, Toolbar, Menu, MenuItem, Button, Grid, Avatar } from "@mui/material";
import { withStyles } from 'tss-react/mui';
import LogoPNG from './logos/LogoPNG.png'
import { authenticationService } from './services/auth_service';
import { history } from './services/history'

const useStyles = (theme, props) => ({
    header: {
        display: 'flex',
        flexDirection: 'row',
        minHeight: '6vh',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    avatar: {
        width: theme.spacing(3),
        height: theme.spacing(3),
        marginRight: theme.spacing(1)
    }
});
class UserMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openClose: false,
            anchorEl: null,
        }
    }

    render() {
        if (this.props.userData !== null) {
            return (
                <div>
                    <Button style={{ color: '#ffffff' }} aria-controls="menu-login" aria-haspopup="true" 
                        onClick={e => this.setState({ openClose: true, anchorEl: e.currentTarget })} >
                        <Avatar className={this.props.classes.avatar} />
                        {(!this.props.userData.is_superuser && !this.props.userData.is_staff) && this.props.userData.cpf}
                        {this.props.userData.is_staff && this.props.userData.name}
                    </Button>
                    <Menu open={this.state.openClose} onClose={e => this.setState({ openClose: false })} anchorEl={this.state.anchorEl}>
                        {this.props.userData.is_superuser && <MenuItem onClick={e => { history.push("/Admin") }}>Página de Administrador</MenuItem>}
                        {this.props.userData.is_superuser && <MenuItem onClick={e => { history.push("/Log") }}>Consultar Log</MenuItem>}
                        {this.props.userData.is_superuser && <MenuItem onClick={e => { history.push("/Dashboard") }}>Dashboard</MenuItem>}
                        {this.props.userData.is_staff && <MenuItem onClick={e => { history.push("/Funcionario") }}>Página de Funcionário</MenuItem>}
                        {this.props.userData.is_staff && (!this.props.userData.is_superuser) && <MenuItem onClick={e => { history.push("/AlterarSenhaFuncionario") }}>Trocar senha</MenuItem>}
                        {this.props.userData.is_staff && this.props.userData.is_superuser && <MenuItem onClick={e => { history.push("/AlterarSenhaAdmin") }}>Trocar senha</MenuItem>}
                        {(!this.props.userData.is_superuser && !this.props.userData.is_staff) && <MenuItem onClick={e => { history.push("/Familia") }}>Resultados</MenuItem>}
      
                        {<MenuItem onClick= {e => { history.push("/Sobre")}}>Sobre</MenuItem>}
                        {(this.props.userData.is_staff | this.props.userData.is_superuser)?
                            <MenuItem onClick={e => { authenticationService.logout(); history.push("/")}}>Sair</MenuItem>:
                            <MenuItem onClick={e => { authenticationService.logoutFamilias(this.props.userData)}}>Sair</MenuItem>
                        }
                    </Menu>
                </div>
            )
        }
        else return (<div />);
    }
}

class Header extends React.Component {
    render() {
        const { classes } = this.props
        return (
            <AppBar position="sticky" style={{ margin: 0 }}>
                <Toolbar >
                    <Grid container direction="row" sx={{alignItems: 'center', justifyContent: "space-between", width: '100%'}}>
                            <Box style={{ display: 'flex' }}>
                                <Link to="/"><img src={LogoPNG} width="30px" height="30px" alt="" /></Link>
                                <Typography variant="h5" >Resultado do Teste do Pezinho</Typography>
                            </Box>
                            <UserMenu userData={this.props.userData} classes={classes} />
                    </Grid>
                </Toolbar>
            </AppBar>

        );
    }
}
export default withStyles(Header, useStyles);
